import { formatDate } from 'helpers/date/formatDate';

export const displayQuizDate = (debut: string, fin: string) => {
  return (
    'Du ' + formatDate(new Date(debut)) + ' au ' + formatDate(new Date(fin))
  );
};

export const displayNote = (note: number, date: string) => {
  return note.toString() + ' / 20 | Date : ' + formatDate(new Date(date));
};
